<script setup>

import { defineProps} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra"
]);

//==================================================================//
//======================== FollowUps Header =======================//
//==================================================================//

let followUpsHeaders = [
    { text: 'Codigo',                   value: 'codigo',            class:"c-followup__header",    cellClass:'c-followup__cell', width:"88px"},
    { text: 'Observação',               value: 'observacao',        class:"c-followup__header",    cellClass:'c-followup__cell', width:"180px"},
    { text: 'Data de Entrega',          value: 'dataEntrega',       class:"c-followup__header",    cellClass:'c-followup__cell', width:"180px"},
    { text: 'Data de Criação',          value: 'dataCriacao',       class:"c-followup__header",    cellClass:'c-followup__cell', width:"180px"},
]

</script>

<template>

    <v-card
        class="c-followups"
    >

        <v-card-title
            class="c-followups__titulo"
        >
        
            <h3>FollowUps</h3>

        </v-card-title>

        <div
            class="c-followups__conteudo"
        >

            <v-data-table
                class="c-followups__tabela elevation-1"
                :headers="followUpsHeaders"
                :items="pedidoDeCompra?.followUps"
                :items-per-page="-1"
                item-key="id"
            >

            </v-data-table>

        </div>

    </v-card>


</template>

<style scoped>

.c-campo{
    pointer-events: none;
}

.c-followups__tabela{
    display: grid;
    white-space: nowrap;
}

</style>